import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { svg } from '../assets/svg';
import { theme } from '../constants';
import { components } from '../components';
import { colors } from '../constants/colors';
import { CrossSvg } from '../assets/svg/CrossSvg';
import { LocationSvg } from '../assets/svg/MyLocaiton';
import { LocationIconSvg } from '../assets/svg/LocationIconSvg';
import useApi from '../customHook/useApi';
import { localityUrl } from '../environment';
import locationAllow from '../assets/nestfin/map.png'





const popularLocalities = [
    {
        id: 1,
        locality: 'GTB Nagar',
        city: 'Delhi',
    },
    {
        id: 2,
        locality: 'Mukherjee Nagar',
        city: 'Delhi',
    },
    {
        id: 3,
        locality: 'Model Town',
        city: 'Delhi',
    },
    {
        id: 4,
        locality: 'Shalimar Bagh',
        city: 'Delhi',
    },
];

type Locality = {
    locality_id: number;
    locality_name: string;
    latitude: number;
    longitude: number;
};

export interface LocalityResponse {
    success: boolean;
    statusCode: number;
    data: Locality[];
    message?: string;
}

export const Onboarding6: React.FC = () => {

    // Define State Here 
    const navigate = hooks.useNavigate();
    const location = useLocation();
    const { pathname } = useLocation();
    // const [searchInput, setSearchInput] = useState<string>([]);
    const [searchInput, setSearchInput] = useState<string[]>([]);
    const [selectedLocalityIds, setSelectedLocalityIds] = useState<number[]>([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [inputValue, setInputValue] = useState("")
    const [localityArray, setLocalityArray] = useState<Locality[]>([]);
    // const [selectedLocalityData, setSelectedLocalityData] = useState<{ locality_id: number; locality_name: string }[]>([]);

    // city name From Session Storage
    const selectedCity = sessionStorage.getItem("selectedCity")




    // API CALL
    const {
        data: localityData,
        loading: localityLoading,
        callApi: fetchLocalities,
    } = useApi<LocalityResponse>(localityUrl, {
        method: "POST",
        autoCall: false,
        dependencies: [],
    });




    // 1. Trigger API on city change
    useEffect(() => {
        if (selectedCity) {
            fetchLocalities({ cityname: selectedCity });
        }
    }, [selectedCity]);

    // 2. Set data and restore session value (merged)
    // useEffect(() => {
    //     const selectedLocality = sessionStorage.getItem("selectedLocality");

    //     if (selectedLocality) {
    //         try {
    //             const parsedLocality = JSON.parse(selectedLocality);
    //             setSearchInput(parsedLocality);
    //         } catch (error) {
    //             console.error("Failed to parse selectedLocality:", error);
    //         }
    //     }

    //     if (localityData) {
    //         console.log("✅ localityData received:", localityData.data);
    //         setLocalityArray(localityData.data);
    //     }
    // }, [localityData]);

    useEffect(() => {
        const selectedLocality = sessionStorage.getItem("selectedLocality");

        if (selectedLocality) {
            try {
                const parsedLocality = JSON.parse(selectedLocality);

                // ✅ Check if it's a valid non-empty array and doesn't contain only empty string
                if (Array.isArray(parsedLocality) && parsedLocality.length > 0 && parsedLocality[0] !== "") {
                    setSearchInput(parsedLocality);
                } else {
                    console.warn("❗ Ignoring invalid or empty selectedLocality:", parsedLocality);
                }

            } catch (error) {
                console.error("Failed to parse selectedLocality:", error);
            }
        }

        if (localityData) {
            console.log("✅ localityData received:", localityData.data);
            setLocalityArray(localityData.data);
        }
    }, [localityData]);


    // 3. Scroll to top on route change
    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, [pathname]);



    const handleLocalityClick = (locality: string) => {
        if (!searchInput?.includes(locality)) {
            setSearchInput((prev) => [...prev, locality]);
        }
    };


    // const handleApply = () => {
    //     console.log("me hu handleApply", searchInput);

    //     // Save locality names as JSON string (optional)
    //     sessionStorage.setItem("selectedLocality", JSON.stringify(searchInput));

    //     // Save locality IDs as comma-separated string
    //     console.log(`id is here (${selectedLocalityIds.length})`);
    //     console.log(`"${selectedLocalityIds.join(", ")}"`);


    //     sessionStorage.setItem("SelectedLocalityId", `"${selectedLocalityIds.join(", ")}"`);

    //     // Navigate
    //     navigate("/onbording7");
    // };

    // const handleApply = () => {
    //     console.log("me hu handleApply", searchInput);

    //     // Save locality names (overwriting fully for now)
    //     sessionStorage.setItem("selectedLocality", JSON.stringify(searchInput));

    //     // Get previously saved IDs from sessionStorage
    //     const previousIdsRaw = sessionStorage.getItem("SelectedLocalityId");
    //     const previousIds = previousIdsRaw ? previousIdsRaw.replace(/"/g, "").split(",").map(id => id.trim()) : [];

    //     // Merge old and new (and avoid duplicates)
    //     const allIds = Array.from(new Set([...previousIds, ...selectedLocalityIds.map(String)]));
    //     const finalIdString = allIds.join(", ");

    //     console.log(`id is here (${allIds.length})`);
    //     console.log(`"${finalIdString}"`);

    //     // Save updated IDs
    //     sessionStorage.setItem("SelectedLocalityId", `${finalIdString}`);

    //     // Navigate
    //     navigate("/onbording7");
    // };

    const handleApply = () => {
        sessionStorage.setItem("selectedLocality", JSON.stringify(searchInput));

        // Save full data (used for ID lookup later)
        sessionStorage.setItem("selectedLocalityFull", JSON.stringify(
            searchInput.map(name => {
                const match = localityArray.find(l => l.locality_name === name);
                return { locality_name: name, locality_id: match?.locality_id || 0 };
            })
        ));

        const previousIdsRaw = sessionStorage.getItem("SelectedLocalityId");
        const previousIds = previousIdsRaw
            ? previousIdsRaw.split(",").map(id => id.trim())
            : [];

        const currentIds = searchInput.map(name => {
            const match = localityArray.find(l => l.locality_name === name);
            return match ? String(match.locality_id) : "";
        }).filter(Boolean);

        const allIds = Array.from(new Set([...previousIds, ...currentIds]));
        sessionStorage.setItem("SelectedLocalityId", allIds.join(", "));

        navigate("/onbording7");
    };

    // const handleRemoveChips = (locToRemove: string) => {
    //     const updatedSearchInput = searchInput.filter(item => item !== locToRemove);
    //     setSearchInput(updatedSearchInput);
    //     sessionStorage.setItem("selectedLocality", JSON.stringify(updatedSearchInput));

    //     const updatedDropdownData = localityArray.filter(loc =>
    //         !updatedSearchInput?.includes(loc.locality_name) &&
    //         loc.locality_name.toLowerCase().includes(inputValue.toLowerCase())
    //     );

    //     setFilterData(updatedDropdownData);
    // };


    const handleRemoveChips = (locToRemove: string) => {
        // 1. Remove name from search input (string[])
        const updatedSearchInput = searchInput.filter(item => item !== locToRemove);
        setSearchInput(updatedSearchInput);
        sessionStorage.setItem("selectedLocality", JSON.stringify(updatedSearchInput));

        // 2. Remove from full locality objects
        const updatedFullLocalities = localityArray.filter(loc =>
            updatedSearchInput.includes(loc.locality_name)
        );
        sessionStorage.setItem("selectedLocalityFull", JSON.stringify(updatedFullLocalities));

        // 3. Extract and save comma-separated ID string
        const selectedLocalityIds = updatedFullLocalities.map(loc => loc.locality_id);
        sessionStorage.setItem("SelectedLocalityId", selectedLocalityIds.join(","));

        // 4. Update filtered dropdown (if needed)
        const updatedDropdownData = localityArray.filter(loc =>
            !updatedSearchInput.includes(loc.locality_name) &&
            loc.locality_name.toLowerCase().includes(inputValue.toLowerCase())
        );
        setFilterData(updatedDropdownData);
    };


    const handleChangeCity = () => {
        // sessionStorage.clear()
        sessionStorage.removeItem("selectedLocality");
        sessionStorage.removeItem("selectedLocalityFull");
        sessionStorage.removeItem("selectedLocalityId");
        navigate('/onbording5')
    }


    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            const value = e.currentTarget.value.trim();
            if (value && !searchInput?.includes(value)) {
                setSearchInput(prev => [...prev, value]);
            }
            e.currentTarget.value = "";
        }
    };





    const [filterdata, setFilterData] = useState<Locality[]>(localityArray)




    // this is my onchange Event
    const handleLocalityDropDown = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInputValue(value);

        if (value.trim() === "") {
            setShowDropdown(false);
            setFilterData([]);
            return;
        }

        setShowDropdown(true);

        const data = localityArray
            .filter(locality =>
                locality.locality_name.toLowerCase().includes(value.toLowerCase())
            )
            .filter(locality =>
                !searchInput?.includes(locality.locality_name)
            );

        setFilterData(data);
    };


    const handleDropDownClick = (localityName: string, localityId: number) => {
        console.log("Selected ID:", localityId);

        setInputValue("");

        const value = localityName.trim();
        setSearchInput(prev => [...prev, value]); // add locality name

        setSelectedLocalityIds(prev => {
            const updatedIds = [...prev, localityId];

            // Optional: store instantly (if needed)
            // sessionStorage.setItem("SelectedLocality", updatedIds.join(","));

            console.log("All selected IDs (string):", updatedIds.join(","));
            return updatedIds;
        });

        setShowDropdown(false);
    };


    const handleClearInput = () => {
        setInputValue("")
        setShowDropdown(false)
    }

    const [showLocationPopup, setShowLocationPopup] = useState(false);

    // show popup based on locality if yes show 
    useEffect(() => {
        const selectedLocality = sessionStorage.getItem("selectedLocality");

        try {
            const parsedLocality = JSON.parse(selectedLocality || "[]");

            // If we have at least one valid non-empty locality, don't show the popup
            if (Array.isArray(parsedLocality) && parsedLocality.length > 0 && parsedLocality[0] !== "") {
                setShowLocationPopup(false);
            } else {
                setShowLocationPopup(true);
            }
        } catch (error) {
            console.error("Error parsing selectedLocality:", error);
            setShowLocationPopup(true); // show popup if parsing fails
        }
    }, []);




    // useEffect(() => {
    //     const hasShownPopup = localStorage.getItem("locationPopupShown");

    //     if (!hasShownPopup) {
    //         setTimeout(() => {
    //             setShowLocationPopup(true);
    //             localStorage.setItem("locationPopupShown", "true");
    //         }, 1000);
    //     }
    // }, [pathname]);

    const hanldeAllowLocation = (location: string) => {
        setShowLocationPopup(false);

        if (location === "Allow") {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        console.log("User location:", latitude, longitude);

                        // --- Step 1: Find nearest locality using Haversine formula ---
                        const toRad = (value: number) => (value * Math.PI) / 180;

                        const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
                            const R = 6371; // Radius of Earth (km)
                            const dLat = toRad(lat2 - lat1);
                            const dLon = toRad(lon2 - lon1);
                            const a =
                                Math.sin(dLat / 2) ** 2 +
                                Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
                            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                            return R * c;
                        };

                        let nearest = null;
                        let minDist = Number.MAX_VALUE;

                        for (const loc of localityArray) {
                            if (loc.latitude && loc.longitude) {
                                const dist = calculateDistance(latitude, longitude, loc.latitude, loc.longitude);
                                if (dist < minDist) {
                                    minDist = dist;
                                    nearest = loc;
                                }
                            }
                        }

                        // --- Step 2: If nearest locality found, add it ---
                        if (nearest) {
                            const name = nearest.locality_name;
                            const id = nearest.locality_id;

                            setSearchInput((prev) => {
                                if (!prev.includes(name)) {
                                    const updatedNames = [...prev, name];
                                    sessionStorage.setItem("selectedLocality", JSON.stringify(updatedNames));

                                    // Save selectedLocalityFull for mapping name ↔ id
                                    const selectedFull = [...updatedNames].map(localityName => {
                                        const match = localityArray.find(loc => loc.locality_name === localityName);
                                        return {
                                            locality_id: match?.locality_id || 0,
                                            locality_name: localityName
                                        };
                                    });
                                    sessionStorage.setItem("selectedLocalityFull", JSON.stringify(selectedFull));

                                    // Save IDs
                                    const updatedIds = selectedFull.map(item => item.locality_id).join(",");
                                    sessionStorage.setItem("SelectedLocalityId", updatedIds);

                                    navigate("/onbording7");
                                    return updatedNames;
                                } else {
                                    // Already exists, but still store
                                    sessionStorage.setItem("selectedLocality", JSON.stringify(prev));
                                    navigate("/onbording7");
                                    return prev;
                                }
                            });
                        } else {
                            console.log("❌ Could not find nearest locality");
                        }
                    },
                    (error) => {
                        console.error("Geolocation error:", error.message);
                    }
                );
            } else {
                console.error("Geolocation is not supported by this browser.");
            }
        }

        if (location === "Don't Allow") {
            console.log("User denied location access.");
        }
    };

    // const hanldeAllowLocation = (location: string) => {
    //     setShowLocationPopup(false);

    //     if (location === "Allow") {
    //         // alert("ho gya")
    //         if (navigator.geolocation) {
    //             navigator.geolocation.getCurrentPosition(
    //                 (position) => {
    //                     const { latitude, longitude } = position.coords;
    //                     console.log("User location:", latitude, longitude);

    //                     const defaultLocality = "Mukherjee Nagar, Delhi";
    //                     // setInputValue(defaultLocality);

    //                     // Add to array if not already included
    //                     setSearchInput((prev) => {
    //                         if (!prev.includes(defaultLocality)) {
    //                             const updated = [...prev, defaultLocality];
    //                             sessionStorage.setItem("selectedLocality", JSON.stringify(updated)); // ✅ Save correct value
    //                             navigate("/onbording7"); // ✅ Move inside so it happens *after* storage
    //                             return updated;
    //                         } else {
    //                             sessionStorage.setItem("selectedLocality", JSON.stringify(prev));
    //                             navigate("/onbording7");
    //                             return prev;
    //                         }
    //                     });


    //                 },
    //                 (error) => {
    //                     console.error("Geolocation error:", error.message);
    //                 }
    //             );
    //         } else {
    //             console.error("Geolocation is not supported by this browser.");
    //         }
    //     }

    //     if (location === "Don't Allow") {
    //         console.log("This is Don't Allow Block");
    //     }
    // };


    // Start component here



    const renderHeader = (): JSX.Element => {
        return (
            <components.Header
                title=''
                goBack={true}
                skip={true}
                clear={false}
                clearOnClicked={() => { }}
            />
        );
    };

    const renderTitle = (): JSX.Element => {
        return (
            <div className='container' style={{ marginTop: 30 }}>
                <p className='headingCity ' style={{ textAlign: "left" }}>   You are looking to rent in</p>

                <div className='changeCityContainer'>
                    <p className='paraCity leftText'>
                        Select Locality in <span className="cityHighlight">{selectedCity}</span>
                    </p>
                    <p
                        className='paraCity leftText boldText'
                        // onClick={() => navigate('/onbording5')}
                        onClick={handleChangeCity}
                    >
                        Change City</p>
                </div>


            </div>
        );
    };

    const renderLocalityList = (): JSX.Element => {
        return (
            <div className="container" style={{ marginTop: 40 }}>
                <p className='paraCity leftText '>Popular Localities</p>
                <div
                    style={{
                        maxHeight: 300,
                        overflowY: 'auto',
                    }}
                >
                    {localityArray.slice(4, 8).map((item) => (
                        <div
                            key={item.locality_id}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px',
                                border: '1px solid #ccc',
                                borderRadius: 5,
                                marginBottom: 10,
                            }}
                            onClick={() => handleLocalityClick(item.locality_name)}

                        >
                            <div
                                style={{
                                    flex: '0 0 20px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginRight: 12,
                                }}
                            >
                                <svg
                                    style={{ width: '20px', height: '20px' }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M12 4v16m8-8H4"
                                    />
                                </svg>
                            </div>

                            <div style={{ flex: 1 }}>
                                <text.T14
                                    style={{
                                        color: '#333',
                                        // fontWeight: 'bold',
                                        marginBottom: 5,
                                        // fontSize: "10px"
                                    }}
                                >
                                    {item.locality_name}
                                </text.T14>

                            </div>

                        </div>
                    ))}


                </div>
            </div>
        );
    };
    // const renderLocalityList = (): JSX.Element => {
    //     return (
    //         <div className="container" style={{ marginTop: 40 }}>
    //             <p className='paraCity leftText '>Popular Localities</p>
    //             <div
    //                 style={{
    //                     maxHeight: 300,
    //                     overflowY: 'auto',
    //                 }}
    //             >
    //                 {popularLocalities.map((item) => (
    //                     <div
    //                         key={item.id}
    //                         style={{
    //                             display: 'flex',
    //                             alignItems: 'center',
    //                             padding: '8px',
    //                             border: '1px solid #ccc',
    //                             borderRadius: 5,
    //                             marginBottom: 10,
    //                         }}
    //                         onClick={() => handleLocalityClick(item.locality)}

    //                     >
    //                         <div
    //                             style={{
    //                                 flex: '0 0 20px',
    //                                 display: 'flex',
    //                                 justifyContent: 'center',
    //                                 alignItems: 'center',
    //                                 marginRight: 12,
    //                             }}
    //                         >
    //                             <svg
    //                                 style={{ width: '20px', height: '20px' }}
    //                                 xmlns="http://www.w3.org/2000/svg"
    //                                 fill="none"
    //                                 viewBox="0 0 24 24"
    //                                 stroke="currentColor"
    //                             >
    //                                 <path
    //                                     strokeLinecap="round"
    //                                     strokeLinejoin="round"
    //                                     strokeWidth="2"
    //                                     d="M12 4v16m8-8H4"
    //                                 />
    //                             </svg>
    //                         </div>

    //                         <div style={{ flex: 1 }}>
    //                             <text.T14
    //                                 style={{
    //                                     color: '#333',
    //                                     // fontWeight: 'bold',
    //                                     marginBottom: 5,
    //                                     // fontSize: "10px"
    //                                 }}
    //                             >
    //                                 {item.locality}
    //                             </text.T14>

    //                         </div>

    //                     </div>
    //                 ))}


    //             </div>
    //         </div>
    //     );
    // };

    const renderButton = (): JSX.Element => {
        return (
            <div
                id="onbording3"
                style={{ backgroundColor: "#7065F0", color: "white" }}
                onClick={handleApply}
            >
                <span>Apply</span>
            </div>

        );
    };

    const renderSearchBar = (): JSX.Element => {
        return (
            <div className="container">
                <div
                    className="searchBar"
                    style={{
                        marginTop: "9px",
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        padding: "5px 16px",
                        gap: "6px",
                    }}
                >
                    <span style={{ flexShrink: 0 }}>
                        <svg.SearchSvg />
                    </span>



                    {/* {searchInput.length > 0 && <div> | </div>} */}
                    {/* Flexible input field */}
                    <input
                        type="text"
                        placeholder="Search Localities here"
                        className="searchInput"
                        maxLength={30}
                        style={{
                            border: "none",
                            outline: "none",
                            flex: 1,
                            minWidth: "120px",
                        }}
                        value={inputValue}
                        // onKeyDown={handleKeyDown}
                        onChange={(e) => handleLocalityDropDown(e)}
                    />

                    {
                        inputValue && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
                            <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

                        </span>
                    }

                </div>
                {/* Chips for selected localities */}
                {searchInput.length > 0 && <div
                    style={{
                        display: "flex",
                        overflow: "auto",
                        flexWrap: "nowrap",
                        gap: "6px",
                        flex: 1,
                        margin: "18px 0"
                    }}>

                    {searchInput.slice().reverse().map((loc, idx) => (
                        <div
                            key={idx}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#7065f0d6",
                                borderRadius: "5px",
                                padding: "9px 10px",
                                fontSize: "14px",
                                whiteSpace: "nowrap",
                                color: "white"
                            }}
                        >
                            <span>{loc}</span>
                            <span
                                style={{
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    color: "#fff",
                                    marginLeft: "8px",

                                }}
                                onClick={() => handleRemoveChips(loc)}
                            >
                                ×
                            </span>
                        </div>
                    ))}

                </div>}


                {/* Show Dropdown when typing */}
                {/* {
                    showDropdown && (
                        <div className='cityResult'>
                            {
                                filterdata.length > 0 ? (
                                    filterdata.map((item, index) => (
                                        <p key={index} onClick={() => handleDropDownClick(item.locality)}>
                                            {item.locality} | {item.city}
                                        </p>
                                    ))
                                ) : (
                                    <p style={{ padding: "8px" }}>No results found</p>
                                )
                            }
                        </div>
                    )
                } */}

                {showDropdown && (
                    <div className="localityResult">
                        {filterdata.length > 0 ? (
                            filterdata.map((item, index) => {
                                // console.log("Dropdown Item:", item); 
                                return (
                                    <p key={index} onClick={() => handleDropDownClick(item.locality_name, item.locality_id)}>
                                        <span role="img" aria-label="location">
                                            <LocationIconSvg width={15} height={15} style={{ marginTop: 8 }} />
                                        </span>{" "}
                                        {item.locality_name}
                                    </p>
                                );
                            })
                        ) : (
                            <p className="noResult">No results found</p>
                        )}
                    </div>
                )}




                <div className="useLocation" style={{ marginTop: "10px" }}
                    onClick={() => setShowLocationPopup(true)}
                >
                    <svg.LocationSvg />
                    <span>Use My Current Location</span>
                </div>
            </div>
        );
    };

    const renderContent = (): JSX.Element => {
        return (
            <main
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '100dvh', // or '100vh' if preferred
                    paddingBottom: 10,
                    overflow: "hidden"
                }}
            >
                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                    }}
                >
                    {renderTitle()}
                    {renderSearchBar()}
                    {renderLocalityList()}
                </div>

                <div style={{ padding: '0 20px 10px' }}>
                    {renderButton()}
                </div>
            </main>

        );
    };

    const renderFetchLocation = (): JSX.Element => {
        return (
            <h1 style={{ color: "black" }}>I am location Code Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis voluptatum reprehenderit aut quaerat numquam, eum quidem maiores delectus molestiae itaque obcaecati ea ullam id unde odio distinctio libero ex explicabo.</h1>
        )
    }

    return (
        <>
            {renderHeader()}
            {renderContent()}
            {/* {renderFetchLocation()} */}

            {showLocationPopup &&
                <div className='location-overlay'>
                    <div className="location-modal">
                        <div className='location-buttons'>
                            <div className='img-container'>
                                <img src={locationAllow} alt="Location" width="100" />
                            </div>
                            <div className="locationContent">
                                <h3>Allow your location </h3>
                                <p>
                                    To help you find the best options near you, we need access to your location.
                                    Your privacy is important to us.
                                </p>
                            </div>
                            <button className='allow-btn' onClick={() => hanldeAllowLocation("Allow")}>Allow </button>
                            <button className='deny-btn' onClick={() => hanldeAllowLocation("Don't Allow")}>Don't Allow</button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};



// // OLD 21-06-2025*****************


// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { CrossSvg } from '../assets/svg/CrossSvg';
// import { LocationSvg } from '../assets/svg/MyLocaiton';
// import { LocationIconSvg } from '../assets/svg/LocationIconSvg';
// import useApi from '../customHook/useApi';
// import { localityUrl } from '../environment';
// import locationAllow from '../assets/nestfin/map.png'





// const popularLocalities = [
//     {
//         id: 1,
//         locality: 'GTB Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 2,
//         locality: 'Mukherjee Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 3,
//         locality: 'Model Town',
//         city: 'Delhi',
//     },
//     {
//         id: 4,
//         locality: 'Shalimar Bagh',
//         city: 'Delhi',
//     },
// ];

// type Locality = {
//     locality_id: number;
//     locality_name: string;
// };

// export interface LocalityResponse {
//     success: boolean;
//     statusCode: number;
//     data: Locality[];
//     message?: string;
// }
// export const Onboarding6: React.FC = () => {

//     // Define State Here
//     const navigate = hooks.useNavigate();
//     const location = useLocation();
//     const { pathname } = useLocation();
//     // const [searchInput, setSearchInput] = useState<string>([]);

//     const [searchInput, setSearchInput] = useState<string[]>([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [inputValue, setInputValue] = useState("")
//     const [localityArray, setLocalityArray] = useState<Locality[]>([]);
//     // city name From Session Storage
//     const selectedCity = sessionStorage.getItem("selectedCity")




//     // API CALL
//     const {
//         data: localityData,
//         loading: localityLoading,
//         callApi: fetchLocalities,
//     } = useApi<LocalityResponse>(localityUrl, {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });




//     // 1. Trigger API on city change

//     useEffect(() => {
//         if (selectedCity) {
//             fetchLocalities({ cityname: selectedCity });
//         }
//     }, [selectedCity]);

//     // 2. Set data and restore session value (merged)
//     useEffect(() => {
//         const selectedLocality = sessionStorage.getItem("selectedLocality");

//         if (selectedLocality) {
//             try {
//                 const parsedLocality = JSON.parse(selectedLocality);
//                 setSearchInput(parsedLocality);
//             } catch (error) {
//                 console.error("Failed to parse selectedLocality:", error);
//             }
//         }

//         if (localityData) {
//             console.log("✅ localityData received:", localityData.data);
//             setLocalityArray(localityData.data);
//         }
//     }, [localityData]);

//     // 3. Scroll to top on route change
//     useEffect(() => {
//         window.scrollTo(0, 0);
//         document.documentElement.scrollTop = 0;
//     }, [pathname]);



//     // // SET THE PAYLOAD
//     // useEffect(() => {
//     //     if (selectedCity) {
//     //         fetchLocalities({ statename: selectedCity });
//     //     }
//     // }, [selectedCity]);





//     // // SET RESULT TO STATE
//     // useEffect(() => {
//     //     if (localityData) {
//     //         console.log("✅ localityData received:", localityData.data);
//     //         setLocalityArray(localityData.data)
//     //     }
//     // }, [localityData]);




//     // useEffect(() => {
//     //     const scrollToTop = () => {
//     //         window.scrollTo(0, 0);
//     //         document.documentElement.scrollTop = 0;
//     //     };
//     //     scrollToTop();
//     // }, [pathname]);


//     // useEffect(() => {
//     //     const selectedLocality = sessionStorage.getItem("selectedLocality")
//     //     if (selectedLocality) {
//     //         try {
//     //             const parsedLocality = JSON.parse(selectedLocality);
//     //             setSearchInput(parsedLocality);
//     //         } catch (error) {
//     //             console.error("Failed to parse selectedLocality:", error);
//     //         }
//     //     }
//     // }, [])


//     const handleLocalityClick = (locality: string) => {
//         if (!searchInput.includes(locality)) {
//             setSearchInput((prev) => [...prev, locality]);
//         }
//     };


//     const handleApply = () => {
//         console.log("handleApply", searchInput);
//         sessionStorage.setItem("selectedLocality", JSON.stringify(searchInput))
//         navigate("/onbording7")

//     }

//     const handleRemoveChips = (locToRemove: string) => {
//         const updatedSearchInput = searchInput.filter(item => item !== locToRemove);
//         setSearchInput(updatedSearchInput);
//         sessionStorage.setItem("selectedLocality", JSON.stringify(updatedSearchInput));

//         const updatedDropdownData = localityArray.filter(loc =>
//             !updatedSearchInput.includes(loc.locality_name) &&
//             loc.locality_name.toLowerCase().includes(inputValue.toLowerCase())
//         );

//         setFilterData(updatedDropdownData);
//     };


//     const handleChangeCity = () => {
//         sessionStorage.clear()
//         navigate('/onbording5')
//     }


//     // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     //     if (e.key === "Enter") {
//     //         const value = e.currentTarget.value.trim();
//     //         if (value && !searchInput.includes(value)) {
//     //             setSearchInput(prev => [...prev, value]);
//     //         }
//     //         e.currentTarget.value = "";
//     //     }
//     // };





//     const [filterdata, setFilterData] = useState<Locality[]>(localityArray)




//     // this is my onchange Event
//     const handleLocalityDropDown = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = e.target.value;
//         setInputValue(value);

//         if (value.trim() === "") {
//             setShowDropdown(false);
//             setFilterData([]);
//             return;
//         }

//         setShowDropdown(true);

//         const data = localityArray
//             .filter(locality =>
//                 locality.locality_name.toLowerCase().includes(value.toLowerCase())
//             )
//             .filter(locality =>
//                 !searchInput.includes(locality.locality_name)
//             );

//         setFilterData(data);
//     };

//     const handleDropDownClick = (localityName: string) => {
//         setInputValue("");
//         const value = localityName.trim();
//         setSearchInput(prev => [...prev, value]);
//         setShowDropdown(false);
//     };

//     const handleClearInput = () => {
//         setInputValue("")
//         setShowDropdown(false)
//     }

//     const [showLocationPopup, setShowLocationPopup] = useState(false);

//     useEffect(() => {
//         const hasShownPopup = localStorage.getItem("locationPopupShown");

//         if (!hasShownPopup) {
//             setTimeout(() => {
//                 setShowLocationPopup(true);
//                 localStorage.setItem("locationPopupShown", "true");
//             }, 1000);
//         }
//     }, [pathname]);


//     // const hanldeAllowLocation = (location: string) => {
//     //     setShowLocationPopup(false);

//     //     if (location === "Allow") {
//     //         // console.log("this is Allow Block");

//     //         if (navigator.geolocation) {
//     //             navigator.geolocation.getCurrentPosition(
//     //                 (position) => {
//     //                     const { latitude, longitude } = position.coords;
//     //                     console.log("User location:", latitude, longitude);

//     //                     // You can use these coordinates to fetch nearby options or update your app state
//     //                     // navigate("/onbording7")
//     //                     setInputValue("Mukherjee Nagar, Delhi")
//     //                 },
//     //                 (error) => {
//     //                     console.error("Geolocation error:", error.message);
//     //                 }
//     //             );
//     //         } else {
//     //             console.error("Geolocation is not supported by this browser.");
//     //         }
//     //     }

//     //     if (location === "Don't Allow") {
//     //         console.log("This is Don't Allow Block");
//     //     }
//     // };



//     // Start component here


//     const hanldeAllowLocation = (location: string) => {
//         setShowLocationPopup(false);

//         if (location === "Allow") {
//             // alert("ho gya")
//             if (navigator.geolocation) {
//                 navigator.geolocation.getCurrentPosition(
//                     (position) => {
//                         const { latitude, longitude } = position.coords;
//                         console.log("User location:", latitude, longitude);

//                         const defaultLocality = "Mukherjee Nagar, Delhi";
//                         // setInputValue(defaultLocality);

//                         // Add to array if not already included
//                         setSearchInput((prev) => {
//                             if (!prev.includes(defaultLocality)) {
//                                 const updated = [...prev, defaultLocality];
//                                 sessionStorage.setItem("selectedLocality", JSON.stringify(updated)); // ✅ Save correct value
//                                 navigate("/onbording7"); // ✅ Move inside so it happens *after* storage
//                                 return updated;
//                             } else {
//                                 sessionStorage.setItem("selectedLocality", JSON.stringify(prev));
//                                 navigate("/onbording7");
//                                 return prev;
//                             }
//                         });


//                     },
//                     (error) => {
//                         console.error("Geolocation error:", error.message);
//                     }
//                 );
//             } else {
//                 console.error("Geolocation is not supported by this browser.");
//             }
//         }

//         if (location === "Don't Allow") {
//             console.log("This is Don't Allow Block");
//         }
//     };


//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <p className='headingCity ' style={{ textAlign: "left" }}>   You are looking to rent in</p>

//                 <div className='changeCityContainer'>
//                     <p className='paraCity leftText'>
//                         Select Locality in <span className="cityHighlight">{selectedCity}</span>
//                     </p>
//                     <p
//                         className='paraCity leftText boldText'
//                         // onClick={() => navigate('/onbording5')}
//                         onClick={handleChangeCity}
//                     >
//                         Change City</p>
//                 </div>


//             </div>
//         );
//     };

//     const renderLocalityList = (): JSX.Element => {
//         return (
//             <div className="container" style={{ marginTop: 40 }}>
//                 <p className='paraCity leftText '>Popular Localities</p>
//                 <div
//                     style={{
//                         maxHeight: 300,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {popularLocalities.map((item) => (
//                         <div
//                             key={item.id}
//                             style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 padding: '8px',
//                                 border: '1px solid #ccc',
//                                 borderRadius: 5,
//                                 marginBottom: 10,
//                             }}
//                             onClick={() => handleLocalityClick(item.locality)}

//                         >
//                             <div
//                                 style={{
//                                     flex: '0 0 20px',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     marginRight: 12,
//                                 }}
//                             >
//                                 <svg
//                                     style={{ width: '20px', height: '20px' }}
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                 >
//                                     <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth="2"
//                                         d="M12 4v16m8-8H4"
//                                     />
//                                 </svg>
//                             </div>

//                             <div style={{ flex: 1 }}>
//                                 <text.T14
//                                     style={{
//                                         color: '#333',
//                                         // fontWeight: 'bold',
//                                         marginBottom: 5,
//                                         // fontSize: "10px"
//                                     }}
//                                 >
//                                     {item.locality}
//                                 </text.T14>

//                             </div>

//                         </div>
//                     ))}


//                 </div>
//             </div>
//         );
//     };

//     const renderButton = (): JSX.Element => {
//         return (
//             <div
//                 id="onbording3"
//                 style={{ backgroundColor: "#7065F0", color: "white" }}
//                 onClick={handleApply}
//             >
//                 <span>Apply</span>
//             </div>

//         );
//     };

//     const renderSearchBar = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div
//                     className="searchBar"
//                     style={{
//                         marginTop: "9px",
//                         display: "flex",
//                         alignItems: "center",
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                         padding: "5px 16px",
//                         gap: "6px",
//                     }}
//                 >
//                     <span style={{ flexShrink: 0 }}>
//                         <svg.SearchSvg />
//                     </span>



//                     {/* {searchInput.length > 0 && <div> | </div>} */}
//                     {/* Flexible input field */}
//                     <input
//                         type="text"
//                         placeholder="Search Localities here"
//                         className="searchInput"
//                         maxLength={30}
//                         style={{
//                             border: "none",
//                             outline: "none",
//                             flex: 1,
//                             minWidth: "120px",
//                         }}
//                         value={inputValue}
//                         // onKeyDown={handleKeyDown}
//                         onChange={(e) => handleLocalityDropDown(e)}
//                     />

//                     {
//                         inputValue && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
//                             <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

//                         </span>
//                     }

//                 </div>
//                 {/* Chips for selected localities */}
//                 {searchInput.length > 0 && <div
//                     style={{
//                         display: "flex",
//                         overflow: "auto",
//                         flexWrap: "nowrap",
//                         gap: "6px",
//                         flex: 1,
//                         margin: "18px 0"
//                     }}>

//                     {searchInput.slice().reverse().map((loc, idx) => (
//                         <div
//                             key={idx}
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 backgroundColor: "#7065f0d6",
//                                 borderRadius: "5px",
//                                 padding: "9px 10px",
//                                 fontSize: "14px",
//                                 whiteSpace: "nowrap",
//                                 color: "white"
//                             }}
//                         >
//                             <span>{loc}</span>
//                             <span
//                                 style={{
//                                     cursor: "pointer",
//                                     fontWeight: "bold",
//                                     color: "#fff",
//                                     marginLeft: "8px",

//                                 }}
//                                 onClick={() => handleRemoveChips(loc)}
//                             >
//                                 ×
//                             </span>
//                         </div>
//                     ))}

//                 </div>}


//                 {/* Show Dropdown when typing */}
//                 {/* {
//                     showDropdown && (
//                         <div className='cityResult'>
//                             {
//                                 filterdata.length > 0 ? (
//                                     filterdata.map((item, index) => (
//                                         <p key={index} onClick={() => handleDropDownClick(item.locality)}>
//                                             {item.locality} | {item.city}
//                                         </p>
//                                     ))
//                                 ) : (
//                                     <p style={{ padding: "8px" }}>No results found</p>
//                                 )
//                             }
//                         </div>
//                     )
//                 } */}

//                 {showDropdown && (
//                     <div className="localityResult">
//                         {filterdata.length > 0 ? (
//                             filterdata.map((item, index) => (
//                                 <p key={index} onClick={() => handleDropDownClick(item.locality_name)}>
//                                     <span role="img" aria-label="location">
//                                         <LocationIconSvg width={15} height={15} style={{ marginTop: 8 }} />
//                                     </span>{" "}
//                                     {item.locality_name}
//                                 </p>
//                             ))
//                         ) : (
//                             <p className="noResult">No results found</p>
//                         )}
//                     </div>
//                 )}



//                 <div className="useLocation" style={{ marginTop: "10px" }}
//                     onClick={() => setShowLocationPopup(true)}
//                 >
//                     <svg.LocationSvg />
//                     <span>Use My Current Location</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh', // or '100vh' if preferred
//                     paddingBottom: 10,
//                     overflow: "hidden"
//                 }}
//             >
//                 <div
//                     style={{
//                         flex: 1,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {renderTitle()}
//                     {renderSearchBar()}
//                     {renderLocalityList()}
//                 </div>

//                 <div style={{ padding: '0 20px 10px' }}>
//                     {renderButton()}
//                 </div>
//             </main>

//         );
//     };

//     const renderFetchLocation = (): JSX.Element => {
//         return (
//             <h1 style={{ color: "black" }}>I am location Code Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis voluptatum reprehenderit aut quaerat numquam, eum quidem maiores delectus molestiae itaque obcaecati ea ullam id unde odio distinctio libero ex explicabo.</h1>
//         )
//     }

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//             {/* {renderFetchLocation()} */}

//             {showLocationPopup &&
//                 <div className='location-overlay'>
//                     <div className="location-modal">
//                         <div className='location-buttons'>
//                             <div className='img-container'>
//                                 <img src={locationAllow} alt="Location" width="100" />
//                             </div>
//                             <div className="locationContent">
//                                 <h3>Allow your location </h3>
//                                 <p>
//                                     To help you find the best options near you, we need access to your location.
//                                     Your privacy is important to us.
//                                 </p>
//                             </div>
//                             <button className='allow-btn' onClick={() => hanldeAllowLocation("Allow")}>Allow </button>
//                             <button className='deny-btn' onClick={() => hanldeAllowLocation("Don't Allow")}>Don't Allow</button>
//                         </div>
//                     </div>
//                 </div>
//             }
//         </>
//     );
// };



// // OLD 21-06-2025*****************


// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { CrossSvg } from '../assets/svg/CrossSvg';
// import { LocationSvg } from '../assets/svg/MyLocaiton';
// import { LocationIconSvg } from '../assets/svg/LocationIconSvg';
// import useApi from '../customHook/useApi';
// import { localityUrl } from '../environment';
// import locationAllow from '../assets/nestfin/map.png'





// const popularLocalities = [
//     {
//         id: 1,
//         locality: 'GTB Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 2,
//         locality: 'Mukherjee Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 3,
//         locality: 'Model Town',
//         city: 'Delhi',
//     },
//     {
//         id: 4,
//         locality: 'Shalimar Bagh',
//         city: 'Delhi',
//     },
// ];

// type Locality = {
//     locality_id: number;
//     locality_name: string;
// };

// export interface LocalityResponse {
//     success: boolean;
//     statusCode: number;
//     data: Locality[];
//     message?: string;
// }

// export const Onboarding6: React.FC = () => {

//     // Define State Here
//     const navigate = hooks.useNavigate();
//     const location = useLocation();
//     const { pathname } = useLocation();
//     // const [searchInput, setSearchInput] = useState<string>([]);
//     const [searchInput, setSearchInput] = useState<string[]>([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [inputValue, setInputValue] = useState("")
//     const [localityArray, setLocalityArray] = useState<Locality[]>([]);
//     // city name From Session Storage
//     const selectedCity = sessionStorage.getItem("selectedCity")




//     // API CALL
//     const {
//         data: localityData,
//         loading: localityLoading,
//         callApi: fetchLocalities,
//     } = useApi<LocalityResponse>(localityUrl, {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });




//     // 1. Trigger API on city change

//     useEffect(() => {
//         if (selectedCity) {
//             fetchLocalities({ cityname: selectedCity });
//         }
//     }, [selectedCity]);

//     // 2. Set data and restore session value (merged)
//     useEffect(() => {
//         const selectedLocality = sessionStorage.getItem("selectedLocality");

//         if (selectedLocality) {
//             try {
//                 const parsedLocality = JSON.parse(selectedLocality);
//                 setSearchInput(parsedLocality);
//             } catch (error) {
//                 console.error("Failed to parse selectedLocality:", error);
//             }
//         }

//         if (localityData) {
//             console.log("✅ localityData received:", localityData.data);
//             setLocalityArray(localityData.data);
//         }
//     }, [localityData]);

//     // 3. Scroll to top on route change
//     useEffect(() => {
//         window.scrollTo(0, 0);
//         document.documentElement.scrollTop = 0;
//     }, [pathname]);



//     // // SET THE PAYLOAD
//     // useEffect(() => {
//     //     if (selectedCity) {
//     //         fetchLocalities({ statename: selectedCity });
//     //     }
//     // }, [selectedCity]);





//     // // SET RESULT TO STATE
//     // useEffect(() => {
//     //     if (localityData) {
//     //         console.log("✅ localityData received:", localityData.data);
//     //         setLocalityArray(localityData.data)
//     //     }
//     // }, [localityData]);




//     // useEffect(() => {
//     //     const scrollToTop = () => {
//     //         window.scrollTo(0, 0);
//     //         document.documentElement.scrollTop = 0;
//     //     };
//     //     scrollToTop();
//     // }, [pathname]);


//     // useEffect(() => {
//     //     const selectedLocality = sessionStorage.getItem("selectedLocality")
//     //     if (selectedLocality) {
//     //         try {
//     //             const parsedLocality = JSON.parse(selectedLocality);
//     //             setSearchInput(parsedLocality);
//     //         } catch (error) {
//     //             console.error("Failed to parse selectedLocality:", error);
//     //         }
//     //     }
//     // }, [])


//     const handleLocalityClick = (locality: string) => {
//         if (!searchInput.includes(locality)) {
//             setSearchInput((prev) => [...prev, locality]);
//         }
//     };


//     const handleApply = () => {
//         console.log("handleApply", searchInput);
//         sessionStorage.setItem("selectedLocality", JSON.stringify(searchInput))
//         navigate("/onbording7")

//     }

//     const handleRemoveChips = (locToRemove: string) => {
//         const updatedSearchInput = searchInput.filter(item => item !== locToRemove);
//         setSearchInput(updatedSearchInput);
//         sessionStorage.setItem("selectedLocality", JSON.stringify(updatedSearchInput));

//         const updatedDropdownData = localityArray.filter(loc =>
//             !updatedSearchInput.includes(loc.locality_name) &&
//             loc.locality_name.toLowerCase().includes(inputValue.toLowerCase())
//         );

//         setFilterData(updatedDropdownData);
//     };


//     const handleChangeCity = () => {
//         sessionStorage.clear()
//         navigate('/onbording5')
//     }


//     // const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     //     if (e.key === "Enter") {
//     //         const value = e.currentTarget.value.trim();
//     //         if (value && !searchInput.includes(value)) {
//     //             setSearchInput(prev => [...prev, value]);
//     //         }
//     //         e.currentTarget.value = "";
//     //     }
//     // };





//     const [filterdata, setFilterData] = useState<Locality[]>(localityArray)




//     // this is my onchange Event
//     const handleLocalityDropDown = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = e.target.value;
//         setInputValue(value);

//         if (value.trim() === "") {
//             setShowDropdown(false);
//             setFilterData([]);
//             return;
//         }

//         setShowDropdown(true);

//         const data = localityArray
//             .filter(locality =>
//                 locality.locality_name.toLowerCase().includes(value.toLowerCase())
//             )
//             .filter(locality =>
//                 !searchInput.includes(locality.locality_name)
//             );

//         setFilterData(data);
//     };

//     const handleDropDownClick = (localityName: string) => {
//         setInputValue("");
//         const value = localityName.trim();
//         setSearchInput(prev => [...prev, value]);
//         setShowDropdown(false);
//     };

//     const handleClearInput = () => {
//         setInputValue("")
//         setShowDropdown(false)
//     }

//     const [showLocationPopup, setShowLocationPopup] = useState(false);

//     useEffect(() => {
//         const hasShownPopup = localStorage.getItem("locationPopupShown");

//         if (!hasShownPopup) {
//             setTimeout(() => {
//                 setShowLocationPopup(true);
//                 localStorage.setItem("locationPopupShown", "true");
//             }, 1000);
//         }
//     }, [pathname]);


//     // const hanldeAllowLocation = (location: string) => {
//     //     setShowLocationPopup(false);

//     //     if (location === "Allow") {
//     //         // console.log("this is Allow Block");

//     //         if (navigator.geolocation) {
//     //             navigator.geolocation.getCurrentPosition(
//     //                 (position) => {
//     //                     const { latitude, longitude } = position.coords;
//     //                     console.log("User location:", latitude, longitude);

//     //                     // You can use these coordinates to fetch nearby options or update your app state
//     //                     // navigate("/onbording7")
//     //                     setInputValue("Mukherjee Nagar, Delhi")
//     //                 },
//     //                 (error) => {
//     //                     console.error("Geolocation error:", error.message);
//     //                 }
//     //             );
//     //         } else {
//     //             console.error("Geolocation is not supported by this browser.");
//     //         }
//     //     }

//     //     if (location === "Don't Allow") {
//     //         console.log("This is Don't Allow Block");
//     //     }
//     // };



//     // Start component here


//     const hanldeAllowLocation = (location: string) => {
//         setShowLocationPopup(false);

//         if (location === "Allow") {
//             // alert("ho gya")
//             if (navigator.geolocation) {
//                 navigator.geolocation.getCurrentPosition(
//                     (position) => {
//                         const { latitude, longitude } = position.coords;
//                         console.log("User location:", latitude, longitude);

//                         const defaultLocality = "Mukherjee Nagar, Delhi";
//                         // setInputValue(defaultLocality);

//                         // Add to array if not already included
//                         setSearchInput((prev) => {
//                             if (!prev.includes(defaultLocality)) {
//                                 const updated = [...prev, defaultLocality];
//                                 sessionStorage.setItem("selectedLocality", JSON.stringify(updated)); // ✅ Save correct value
//                                 navigate("/onbording7"); // ✅ Move inside so it happens *after* storage
//                                 return updated;
//                             } else {
//                                 sessionStorage.setItem("selectedLocality", JSON.stringify(prev));
//                                 navigate("/onbording7");
//                                 return prev;
//                             }
//                         });


//                     },
//                     (error) => {
//                         console.error("Geolocation error:", error.message);
//                     }
//                 );
//             } else {
//                 console.error("Geolocation is not supported by this browser.");
//             }
//         }

//         if (location === "Don't Allow") {
//             console.log("This is Don't Allow Block");
//         }
//     };


//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <p className='headingCity ' style={{ textAlign: "left" }}>   You are looking to rent in</p>

//                 <div className='changeCityContainer'>
//                     <p className='paraCity leftText'>
//                         Select Locality in <span className="cityHighlight">{selectedCity}</span>
//                     </p>
//                     <p
//                         className='paraCity leftText boldText'
//                         // onClick={() => navigate('/onbording5')}
//                         onClick={handleChangeCity}
//                     >
//                         Change City</p>
//                 </div>


//             </div>
//         );
//     };

//     const renderLocalityList = (): JSX.Element => {
//         return (
//             <div className="container" style={{ marginTop: 40 }}>
//                 <p className='paraCity leftText '>Popular Localities</p>
//                 <div
//                     style={{
//                         maxHeight: 300,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {popularLocalities.map((item) => (
//                         <div
//                             key={item.id}
//                             style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 padding: '8px',
//                                 border: '1px solid #ccc',
//                                 borderRadius: 5,
//                                 marginBottom: 10,
//                             }}
//                             onClick={() => handleLocalityClick(item.locality)}

//                         >
//                             <div
//                                 style={{
//                                     flex: '0 0 20px',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     marginRight: 12,
//                                 }}
//                             >
//                                 <svg
//                                     style={{ width: '20px', height: '20px' }}
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                 >
//                                     <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth="2"
//                                         d="M12 4v16m8-8H4"
//                                     />
//                                 </svg>
//                             </div>

//                             <div style={{ flex: 1 }}>
//                                 <text.T14
//                                     style={{
//                                         color: '#333',
//                                         // fontWeight: 'bold',
//                                         marginBottom: 5,
//                                         // fontSize: "10px"
//                                     }}
//                                 >
//                                     {item.locality}
//                                 </text.T14>

//                             </div>

//                         </div>
//                     ))}


//                 </div>
//             </div>
//         );
//     };

//     const renderButton = (): JSX.Element => {
//         return (
//             <div
//                 id="onbording3"
//                 style={{ backgroundColor: "#7065F0", color: "white" }}
//                 onClick={handleApply}
//             >
//                 <span>Apply</span>
//             </div>

//         );
//     };

//     const renderSearchBar = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div
//                     className="searchBar"
//                     style={{
//                         marginTop: "9px",
//                         display: "flex",
//                         alignItems: "center",
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                         padding: "5px 16px",
//                         gap: "6px",
//                     }}
//                 >
//                     <span style={{ flexShrink: 0 }}>
//                         <svg.SearchSvg />
//                     </span>



//                     {/* {searchInput.length > 0 && <div> | </div>} */}
//                     {/* Flexible input field */}
//                     <input
//                         type="text"
//                         placeholder="Search Localities here"
//                         className="searchInput"
//                         maxLength={30}
//                         style={{
//                             border: "none",
//                             outline: "none",
//                             flex: 1,
//                             minWidth: "120px",
//                         }}
//                         value={inputValue}
//                         // onKeyDown={handleKeyDown}
//                         onChange={(e) => handleLocalityDropDown(e)}
//                     />

//                     {
//                         inputValue && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
//                             <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

//                         </span>
//                     }

//                 </div>
//                 {/* Chips for selected localities */}
//                 {searchInput.length > 0 && <div
//                     style={{
//                         display: "flex",
//                         overflow: "auto",
//                         flexWrap: "nowrap",
//                         gap: "6px",
//                         flex: 1,
//                         margin: "18px 0"
//                     }}>

//                     {searchInput.slice().reverse().map((loc, idx) => (
//                         <div
//                             key={idx}
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 backgroundColor: "#7065f0d6",
//                                 borderRadius: "5px",
//                                 padding: "9px 10px",
//                                 fontSize: "14px",
//                                 whiteSpace: "nowrap",
//                                 color: "white"
//                             }}
//                         >
//                             <span>{loc}</span>
//                             <span
//                                 style={{
//                                     cursor: "pointer",
//                                     fontWeight: "bold",
//                                     color: "#fff",
//                                     marginLeft: "8px",

//                                 }}
//                                 onClick={() => handleRemoveChips(loc)}
//                             >
//                                 ×
//                             </span>
//                         </div>
//                     ))}

//                 </div>}


//                 {/* Show Dropdown when typing */}
//                 {/* {
//                     showDropdown && (
//                         <div className='cityResult'>
//                             {
//                                 filterdata.length > 0 ? (
//                                     filterdata.map((item, index) => (
//                                         <p key={index} onClick={() => handleDropDownClick(item.locality)}>
//                                             {item.locality} | {item.city}
//                                         </p>
//                                     ))
//                                 ) : (
//                                     <p style={{ padding: "8px" }}>No results found</p>
//                                 )
//                             }
//                         </div>
//                     )
//                 } */}

//                 {showDropdown && (
//                     <div className="localityResult">
//                         {filterdata.length > 0 ? (
//                             filterdata.map((item, index) => (
//                                 <p key={index} onClick={() => handleDropDownClick(item.locality_name)}>
//                                     <span role="img" aria-label="location">
//                                         <LocationIconSvg width={15} height={15} style={{ marginTop: 8 }} />
//                                     </span>{" "}
//                                     {item.locality_name}
//                                 </p>
//                             ))
//                         ) : (
//                             <p className="noResult">No results found</p>
//                         )}
//                     </div>
//                 )}



//                 <div className="useLocation" style={{ marginTop: "10px" }}
//                     onClick={() => setShowLocationPopup(true)}
//                 >
//                     <svg.LocationSvg />
//                     <span>Use My Current Location</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh', // or '100vh' if preferred
//                     paddingBottom: 10,
//                     overflow: "hidden"
//                 }}
//             >
//                 <div
//                     style={{
//                         flex: 1,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {renderTitle()}
//                     {renderSearchBar()}
//                     {renderLocalityList()}
//                 </div>

//                 <div style={{ padding: '0 20px 10px' }}>
//                     {renderButton()}
//                 </div>
//             </main>

//         );
//     };

//     const renderFetchLocation = (): JSX.Element => {
//         return (
//             <h1 style={{ color: "black" }}>I am location Code Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis voluptatum reprehenderit aut quaerat numquam, eum quidem maiores delectus molestiae itaque obcaecati ea ullam id unde odio distinctio libero ex explicabo.</h1>
//         )
//     }

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//             {/* {renderFetchLocation()} */}

//             {showLocationPopup &&
//                 <div className='location-overlay'>
//                     <div className="location-modal">
//                         <div className='location-buttons'>
//                             <div className='img-container'>
//                                 <img src={locationAllow} alt="Location" width="100" />
//                             </div>
//                             <div className="locationContent">
//                                 <h3>Allow your location </h3>
//                                 <p>
//                                     To help you find the best options near you, we need access to your location.
//                                     Your privacy is important to us.
//                                 </p>
//                             </div>
//                             <button className='allow-btn' onClick={() => hanldeAllowLocation("Allow")}>Allow </button>
//                             <button className='deny-btn' onClick={() => hanldeAllowLocation("Don't Allow")}>Don't Allow</button>
//                         </div>
//                     </div>
//                 </div>
//             }
//         </>
//     );
// };





// ******************************************/********************************* */
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { CrossSvg } from '../assets/svg/CrossSvg';
// import { LocationSvg } from '../assets/svg/MyLocaiton';
// import { LocationIconSvg } from '../assets/svg/LocationIconSvg';
// import useApi from '../customHook/useApi';
// import { localityUrl } from '../environment';
// import locationAllow from '../assets/nestfin/map.png'





// const popularLocalities = [
//     {
//         id: 1,
//         locality: 'GTB Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 2,
//         locality: 'Mukherjee Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 3,
//         locality: 'Model Town',
//         city: 'Delhi',
//     },
//     {
//         id: 4,
//         locality: 'Shalimar Bagh',
//         city: 'Delhi',
//     },
// ];

// type Locality = {
//     locality_id: number;
//     locality_name: string;
//     latitude?: number;
//     longitude?: number;
// };


// export interface LocalityResponse {
//     success: boolean;
//     statusCode: number;
//     data: Locality[];
//     message?: string;
// }

// export const Onboarding6: React.FC = () => {

//     // Define State Here
//     const navigate = hooks.useNavigate();
//     const location = useLocation();
//     const { pathname } = useLocation();
//     // const [searchInput, setSearchInput] = useState<string>([]);
//     const [searchInput, setSearchInput] = useState<Locality[]>([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [inputValue, setInputValue] = useState("")
//     const [localityArray, setLocalityArray] = useState<Locality[]>([]);
//     // city name From Session Storage
//     const selectedCity = sessionStorage.getItem("selectedCity")




//     // API CALL
//     const {
//         data: localityData,
//         loading: localityLoading,
//         callApi: fetchLocalities,
//     } = useApi<LocalityResponse>(localityUrl, {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });




//     // 1. Trigger API on city change

//     useEffect(() => {
//         if (selectedCity) {
//             fetchLocalities({ cityname: selectedCity });
//         }
//     }, [selectedCity]);

//     // 2. Set data and restore session value (merged)
//     useEffect(() => {
//         const selectedLocality = sessionStorage.getItem("selectedLocality");

//         if (selectedLocality) {
//             try {
//                 const parsedLocality = JSON.parse(selectedLocality);
//                 setSearchInput(parsedLocality);
//             } catch (error) {
//                 console.error("Failed to parse selectedLocality:", error);
//             }
//         }

//         if (localityData) {
//             console.log("✅ localityData received:", localityData.data);
//             setLocalityArray(localityData.data);
//         }
//     }, [localityData]);

//     // 3. Scroll to top on route change
//     useEffect(() => {
//         window.scrollTo(0, 0);
//         document.documentElement.scrollTop = 0;
//     }, [pathname]);



//     const handleLocalityClick = (locality: string) => {
//         const found = localityArray.find(loc => loc.locality_name === locality);
//         if (!found) return;

//         if (!searchInput.some(l => l.locality_id === found.locality_id)) {
//             setSearchInput(prev => [...prev, found]);
//         }
//     };


//     const handleApply = () => {
//         if (searchInput.length > 0) {
//             const ids = searchInput.map(loc => loc.locality_id).join(","); // "804,834"

//             // Store ONLY the IDs as a string
//             sessionStorage.setItem("selectedLocality", ids); // 👈 This line changed
//             localStorage.setItem("localityId", ids); // Optional: if needed

//             console.log("✅ Stored selectedLocality:", ids);
//         } else {
//             sessionStorage.removeItem("selectedLocality");
//             localStorage.removeItem("localityId");
//         }

//         navigate("/onbording7");
//     };



//     const handleRemoveChips = (locToRemove: Locality) => {
//         const updatedSearchInput = searchInput.filter(
//             item => item.locality_id !== locToRemove.locality_id
//         );

//         setSearchInput(updatedSearchInput);
//         sessionStorage.setItem("selectedLocality", JSON.stringify(updatedSearchInput));
//         const updatedIds = updatedSearchInput.map(loc => loc.locality_id).join(",");
//         localStorage.setItem("localityId", updatedIds);

//         const updatedDropdownData = localityArray.filter(loc =>
//             !updatedSearchInput.some(sel => sel.locality_id === loc.locality_id) &&
//             loc.locality_name.toLowerCase().includes(inputValue.toLowerCase())
//         );

//         setFilterData(updatedDropdownData);
//     };




//     const handleChangeCity = () => {
//         sessionStorage.clear()
//         navigate('/onbording5')
//     }


//     const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//         if (e.key === "Enter") {
//             const value = e.currentTarget.value.trim();
//             if (value) {
//                 const found = localityArray.find(loc => loc.locality_name.toLowerCase() === value.toLowerCase());
//                 if (found && !searchInput.some(l => l.locality_id === found.locality_id)) {
//                     setSearchInput(prev => [...prev, found]);
//                 }
//             }
//             e.currentTarget.value = "";
//         }
//     };





//     const [filterdata, setFilterData] = useState<Locality[]>(localityArray)



//     // this is my onchange Event
//     const handleLocalityDropDown = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = e.target.value;
//         setInputValue(value);

//         if (value.trim() === "") {
//             setShowDropdown(false);
//             setFilterData([]);
//             return;
//         }

//         setShowDropdown(true);

//         const data = localityArray
//             .filter(locality =>
//                 locality.locality_name.toLowerCase().includes(value.toLowerCase())
//             )
//             .filter(locality =>
//                 !searchInput.some(sel => sel.locality_id === locality.locality_id)
//             )


//         setFilterData(data);
//     };

//     const handleDropDownClick = (localityName: string) => {
//         const selected = localityArray.find(loc => loc.locality_name === localityName);
//         if (!selected) return;

//         setInputValue("");
//         setSearchInput(prev => {
//             if (!prev.some(item => item.locality_id === selected.locality_id)) {
//                 return [...prev, selected];
//             }
//             return prev;
//         });
//         setShowDropdown(false);
//     };

//     const handleClearInput = () => {
//         setInputValue("")
//         setShowDropdown(false)
//     }

//     const [showLocationPopup, setShowLocationPopup] = useState(false);

//     useEffect(() => {
//         const hasShownPopup = localStorage.getItem("locationPopupShown");

//         if (!hasShownPopup) {
//             setTimeout(() => {
//                 setShowLocationPopup(true);
//                 localStorage.setItem("locationPopupShown", "true");
//             }, 1000);
//         }
//     }, [pathname]);



//     const hanldeAllowLocation = (location: string) => {
//         setShowLocationPopup(false);

//         if (location === "Allow") {
//             if (navigator.geolocation) {
//                 navigator.geolocation.getCurrentPosition(
//                     (position) => {
//                         const { latitude, longitude } = position.coords;
//                         console.log("User location:", latitude, longitude);

//                         // Find nearest locality using Haversine formula
//                         const findNearestLocality = () => {
//                             if (!localityArray.length) return null;

//                             const toRad = (value: number) => (value * Math.PI) / 180;

//                             const distance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
//                                 const R = 6371; // Radius of the Earth in km
//                                 const dLat = toRad(lat2 - lat1);
//                                 const dLon = toRad(lon2 - lon1);
//                                 const a =
//                                     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//                                     Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
//                                     Math.sin(dLon / 2) * Math.sin(dLon / 2);
//                                 const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//                                 return R * c; // in km
//                             };

//                             let nearest = localityArray[0];
//                             let minDist = Number.MAX_VALUE;

//                             for (const loc of localityArray) {
//                                 if (!loc.latitude || !loc.longitude) continue;

//                                 const dist = distance(latitude, longitude, loc.latitude, loc.longitude);
//                                 if (dist < minDist) {
//                                     minDist = dist;
//                                     nearest = loc;
//                                 }
//                             }

//                             return nearest;
//                         };

//                         const nearestLocality = findNearestLocality();

//                         if (nearestLocality) {
//                             setSearchInput((prev) => {
//                                 if (!prev.some(item => item.locality_id === nearestLocality.locality_id)) {
//                                     const updated = [...prev, nearestLocality];

//                                     // Save to storage
//                                     sessionStorage.setItem("selectedLocality", JSON.stringify(updated));
//                                     localStorage.setItem("localityId", updated.map(l => l.locality_id).join(","));
//                                     navigate("/onbording7");
//                                     return updated;
//                                 } else {
//                                     sessionStorage.setItem("selectedLocality", JSON.stringify(prev));
//                                     localStorage.setItem("localityId", prev.map(l => l.locality_id).join(","));
//                                     navigate("/onbording7");
//                                     return prev;
//                                 }
//                             });
//                         } else {
//                             console.log("❌ Could not find nearest locality");
//                         }
//                     },
//                     (error) => {
//                         console.error("Geolocation error:", error.message);
//                     }
//                 );
//             } else {
//                 console.error("Geolocation is not supported by this browser.");
//             }
//         }

//         if (location === "Don't Allow") {
//             console.log("User denied location access.");
//         }
//     };


//     // Start component here

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <p className='headingCity ' style={{ textAlign: "left" }}>   You are looking to rent in</p>

//                 <div className='changeCityContainer'>
//                     <p className='paraCity leftText'>
//                         Select Locality in <span className="cityHighlight">{selectedCity}</span>
//                     </p>
//                     <p
//                         className='paraCity leftText boldText'
//                         // onClick={() => navigate('/onbording5')}
//                         onClick={handleChangeCity}
//                     >
//                         Change City</p>
//                 </div>


//             </div>
//         );
//     };

//     const renderLocalityList = (): JSX.Element => {
//         return (
//             <div className="container" style={{ marginTop: 40 }}>
//                 <p className='paraCity leftText '>Popular Localities</p>
//                 <div
//                     style={{
//                         maxHeight: 300,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {popularLocalities.map((item) => (
//                         <div
//                             key={item.id}
//                             style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 padding: '8px',
//                                 border: '1px solid #ccc',
//                                 borderRadius: 5,
//                                 marginBottom: 10,
//                             }}
//                             onClick={() => handleLocalityClick(item.locality)}

//                         >
//                             <div
//                                 style={{
//                                     flex: '0 0 20px',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     marginRight: 12,
//                                 }}
//                             >
//                                 <svg
//                                     style={{ width: '20px', height: '20px' }}
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                 >
//                                     <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth="2"
//                                         d="M12 4v16m8-8H4"
//                                     />
//                                 </svg>
//                             </div>

//                             <div style={{ flex: 1 }}>
//                                 <text.T14
//                                     style={{
//                                         color: '#333',
//                                         // fontWeight: 'bold',
//                                         marginBottom: 5,
//                                         // fontSize: "10px"
//                                     }}
//                                 >
//                                     {item.locality}
//                                 </text.T14>

//                             </div>

//                         </div>
//                     ))}


//                 </div>
//             </div>
//         );
//     };

//     const renderButton = (): JSX.Element => {
//         return (
//             <div
//                 id="onbording3"
//                 style={{ backgroundColor: "#7065F0", color: "white" }}
//                 onClick={handleApply}
//             >
//                 <span>Apply</span>
//             </div>

//         );
//     };

//     const renderSearchBar = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div
//                     className="searchBar"
//                     style={{
//                         marginTop: "9px",
//                         display: "flex",
//                         alignItems: "center",
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                         padding: "5px 16px",
//                         gap: "6px",
//                     }}
//                 >
//                     <span style={{ flexShrink: 0 }}>
//                         <svg.SearchSvg />
//                     </span>
//                     {/* Flexible input field */}
//                     <input
//                         type="text"
//                         placeholder="Search Localities here"
//                         className="searchInput"
//                         maxLength={30}
//                         style={{
//                             border: "none",
//                             outline: "none",
//                             flex: 1,
//                             minWidth: "120px",
//                         }}
//                         value={inputValue}
//                         // onKeyDown={handleKeyDown}
//                         onChange={(e) => handleLocalityDropDown(e)}
//                     />

//                     {
//                         inputValue && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
//                             <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

//                         </span>
//                     }

//                 </div>
//                 {/* Chips for selected localities */}
//                 {searchInput.length > 0 && <div
//                     style={{
//                         display: "flex",
//                         overflow: "auto",
//                         flexWrap: "nowrap",
//                         gap: "6px",
//                         flex: 1,
//                         margin: "18px 0"
//                     }}>

//                     {searchInput.slice().reverse().map((loc, idx) => (
//                         <div
//                             key={idx}
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 backgroundColor: "#7065f0d6",
//                                 borderRadius: "5px",
//                                 padding: "9px 10px",
//                                 fontSize: "14px",
//                                 whiteSpace: "nowrap",
//                                 color: "white"
//                             }}
//                         >
//                             <span>{loc.locality_name}</span>
//                             <span
//                                 style={{
//                                     cursor: "pointer",
//                                     fontWeight: "bold",
//                                     color: "#fff",
//                                     marginLeft: "8px",

//                                 }}
//                                 onClick={() => handleRemoveChips(loc)}
//                             >
//                                 ×
//                             </span>
//                         </div>
//                     ))}

//                 </div>}



//                 {showDropdown && (
//                     <div className="localityResult">
//                         {filterdata.length > 0 ? (
//                             filterdata.map((item, index) => (
//                                 <p key={index} onClick={() => handleDropDownClick(item.locality_name)}>
//                                     <span role="img" aria-label="location">
//                                         <LocationIconSvg width={15} height={15} style={{ marginTop: 8 }} />
//                                     </span>{" "}
//                                     {item.locality_name}
//                                 </p>
//                             ))
//                         ) : (
//                             <p className="noResult">No results found</p>
//                         )}
//                     </div>
//                 )}



//                 <div className="useLocation" style={{ marginTop: "10px" }}
//                     onClick={() => setShowLocationPopup(true)}
//                 >
//                     <svg.LocationSvg />
//                     <span>Use My Current Location</span>
//                 </div>
//             </div>
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh', // or '100vh' if preferred
//                     paddingBottom: 10,
//                     overflow: "hidden"
//                 }}
//             >
//                 <div
//                     style={{
//                         flex: 1,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {renderTitle()}
//                     {renderSearchBar()}
//                     {renderLocalityList()}
//                 </div>

//                 <div style={{ padding: '0 20px 10px' }}>
//                     {renderButton()}
//                 </div>
//             </main>

//         );
//     };

//     const renderFetchLocation = (): JSX.Element => {
//         return (
//             <h1 style={{ color: "black" }}>I am location Code Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis voluptatum reprehenderit aut quaerat numquam, eum quidem maiores delectus molestiae itaque obcaecati ea ullam id unde odio distinctio libero ex explicabo.</h1>
//         )
//     }

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//             {/* {renderFetchLocation()} */}

//             {showLocationPopup &&
//                 <div className='location-overlay'>
//                     <div className="location-modal">
//                         <div className='location-buttons'>
//                             <div className='img-container'>
//                                 <img src={locationAllow} alt="Location" width="100" />
//                             </div>
//                             <div className="locationContent">
//                                 <h3>Allow your location </h3>
//                                 <p>
//                                     To help you find the best options near you, we need access to your location.
//                                     Your privacy is important to us.
//                                 </p>
//                             </div>
//                             <button className='allow-btn' onClick={() => hanldeAllowLocation("Allow")}>Allow </button>
//                             <button className='deny-btn' onClick={() => hanldeAllowLocation("Don't Allow")}>Don't Allow</button>
//                         </div>
//                     </div>
//                 </div>
//             }
//         </>
//     );
// };








// *******************//////////////////*************************////////////////////*********** */ */




// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { colors } from '../constants/colors';
// import { CrossSvg } from '../assets/svg/CrossSvg';
// import { LocationSvg } from '../assets/svg/MyLocaiton';
// import { LocationIconSvg } from '../assets/svg/LocationIconSvg';
// import useApi from '../customHook/useApi';

// const priceData = [
//     {
//         id: 1,
//         locality: 'GTB Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 2,
//         locality: 'Mukherjee Nagar',
//         city: 'Delhi',
//     },
//     {
//         id: 3,
//         locality: 'Model Town',
//         city: 'Delhi',
//     },
//     {
//         id: 4,
//         locality: 'Shalimar Bagh',
//         city: 'Delhi',
//     },


// ];

// let recentLocations = [
//     'Delhi', 'Mumbai', 'Bengaluru', 'Pune', 'Hyderabad',
// ];




// export interface Locality {
//     locality_id: number;
//     locality_name: string;
// }

// export interface LocalityResponse {
//     success: boolean;
//     statusCode: number;
//     data: Locality[];
//     message?: string;
// }

// export const Onboarding6: React.FC = () => {

//     // Define State Here
//     const navigate = hooks.useNavigate();
//     const location = useLocation();
//     // const [searchInput, setSearchInput] = useState<string>([]);
//     const [searchInput, setSearchInput] = useState<string[]>([]);
//     const [selectedCities, setSelectedCities] = useState<string[]>([]); // for chips
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [inputValue, setInputValue] = useState("")
//     const cityName = useLocation().state?.cityName;
//     const { pathname } = useLocation();
//     const selectedCity = sessionStorage.getItem("selectedCity")

//     const [localityArray, setLocalityArray] = useState([
//         { id: 1, city: "Delhi", locality: "GTB Nagar" },
//         { id: 2, city: "Delhi", locality: "Mukherjee Nagar" },
//         { id: 3, city: "Delhi", locality: "Model Town" },
//         { id: 4, city: "Delhi", locality: "Shalimar Bagh" },
//         { id: 5, city: "Delhi", locality: "Lajpat Nagar" },
//         { id: 6, city: "Delhi", locality: "Kalkaji" },
//         { id: 7, city: "Delhi", locality: "Malviya Nagar" },
//         { id: 8, city: "Delhi", locality: "Saket" },
//         { id: 9, city: "Delhi", locality: "Dwarka" },
//         { id: 10, city: "Delhi", locality: "Rohini" },
//         { id: 11, city: "Delhi", locality: "Janakpuri" },
//         { id: 12, city: "Delhi", locality: "Karol Bagh" },
//         { id: 13, city: "Delhi", locality: "Hauz Khas" },
//         { id: 14, city: "Delhi", locality: "South Extension" },
//         { id: 15, city: "Delhi", locality: "Vasant Kunj" },
//     ]);




//     const {
//         data: localityData,
//         loading: localityLoading,
//         callApi: fetchLocalities,
//     } = useApi<LocalityResponse>("/api/v1/get-pref-localities", {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });





//     useEffect(() => {
//         if (selectedCity) {
//             fetchLocalities({ statename: selectedCity });
//         }
//     }, [selectedCity]);

//     useEffect(() => {
//         if (localityData) {
//             console.log("✅ localityData received:", localityData.data);
//             // setLocalityArray(localityData.data)
//         }
//     }, [localityData]);






//     useEffect(() => {


//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     useEffect(() => {

//         const selectedLocality = sessionStorage.getItem("selectedLocality")
//         if (selectedLocality) {
//             try {
//                 const parsedLocality = JSON.parse(selectedLocality);
//                 setSearchInput(parsedLocality);
//             } catch (error) {
//                 console.error("Failed to parse selectedLocality:", error);
//             }
//         }


//     }, [])


//     const handleLocalityClick = (locality: string) => {
//         if (!searchInput.includes(locality)) {
//             setSearchInput((prev) => [...prev, locality]);
//         }
//     };

//     const handleRemoveCity = (cityToRemove: string) => {
//         recentLocations = recentLocations.filter(city => city !== cityToRemove);
//     };


//     const handleApply = () => {
//         console.log("handleApply", searchInput);
//         sessionStorage.setItem("selectedLocality", JSON.stringify(searchInput))
//         navigate("/onbording7")
//     }

//     // const handleRemoveChips = (locToRemove: string) => {
//     //     console.log(locToRemove);
//     //     const updatedSearchInput = searchInput.filter((item) => item !== locToRemove)
//     //     setSearchInput(updatedSearchInput);
//     //     sessionStorage.setItem("selectedLocality", JSON.stringify(updatedSearchInput));
//     // }


//     const handleRemoveChips = (locToRemove: string) => {
//         const updatedSearchInput = searchInput.filter(item => item !== locToRemove);
//         setSearchInput(updatedSearchInput);
//         sessionStorage.setItem("selectedLocality", JSON.stringify(updatedSearchInput));

//         // Optional: Recalculate dropdown list when chip is removed
//         const updatedDropdownData = localityArray.filter(loc =>
//             !updatedSearchInput.includes(loc.city) &&
//             loc.city.toLowerCase().includes(inputValue.toLowerCase())
//         );
//         setFilterData(updatedDropdownData);
//     };


//     const handleChangeCity = () => {
//         sessionStorage.clear()
//         navigate('/onbording5')
//     }


//     const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//         if (e.key === "Enter") {
//             const value = e.currentTarget.value.trim();
//             if (value && !searchInput.includes(value)) {
//                 setSearchInput(prev => [...prev, value]);
//             }
//             e.currentTarget.value = "";
//         }
//     };


//     // Define type (optional but clean)
//     type Locality = {
//         id: number;
//         city: string;
//         locality: string;
//     };


//     // const localityArray = [
//     //     { id: 1, city: "Delhi", locality: "GTB Nagar" },
//     //     { id: 2, city: "Delhi", locality: "Mukherjee Nagar" },
//     //     { id: 3, city: "Delhi", locality: "Model Town" },
//     //     { id: 4, city: "Delhi", locality: "Shalimar Bagh" },
//     //     { id: 5, city: "Delhi", locality: "Lajpat Nagar" },
//     //     { id: 6, city: "Delhi", locality: "Kalkaji" },
//     //     { id: 7, city: "Delhi", locality: "Malviya Nagar" },
//     //     { id: 8, city: "Delhi", locality: "Saket" },
//     //     { id: 9, city: "Delhi", locality: "Dwarka" },
//     //     { id: 10, city: "Delhi", locality: "Rohini" },
//     //     { id: 11, city: "Delhi", locality: "Janakpuri" },
//     //     { id: 12, city: "Delhi", locality: "Karol Bagh" },
//     //     { id: 13, city: "Delhi", locality: "Hauz Khas" },
//     //     { id: 14, city: "Delhi", locality: "South Extension" },
//     //     { id: 15, city: "Delhi", locality: "Vasant Kunj" },
//     //     // { id: 16, city: "Noida", locality: "Sector 15" },
//     //     // { id: 17, city: "Noida", locality: "Sector 18" },
//     //     // { id: 18, city: "Noida", locality: "Sector 21" },
//     //     // { id: 19, city: "Noida", locality: "Sector 22" },
//     //     // { id: 20, city: "Noida", locality: "Sector 34" },
//     //     // { id: 21, city: "Noida", locality: "Sector 44" },
//     //     // { id: 22, city: "Noida", locality: "Sector 45" },
//     //     // { id: 23, city: "Noida", locality: "Sector 50" },
//     //     // { id: 24, city: "Noida", locality: "Sector 62" },
//     //     // { id: 25, city: "Noida", locality: "Sector 63" },
//     //     // { id: 26, city: "Noida", locality: "Sector 76" },
//     //     // { id: 27, city: "Noida", locality: "Sector 110" },
//     //     // { id: 28, city: "Noida", locality: "Sector 137" },
//     //     // { id: 29, city: "Gurugram", locality: "DLF Phase 1" },
//     //     // { id: 30, city: "Gurugram", locality: "DLF Phase 2" },
//     //     // { id: 31, city: "Gurugram", locality: "DLF Phase 3" },
//     //     // { id: 32, city: "Gurugram", locality: "DLF Phase 4" },
//     //     // { id: 33, city: "Gurugram", locality: "DLF Phase 5" },
//     //     // { id: 34, city: "Gurugram", locality: "Sushant Lok Phase 1" },
//     //     // { id: 35, city: "Gurugram", locality: "Sushant Lok Phase 2" },
//     //     // { id: 36, city: "Gurugram", locality: "MG Road" },
//     //     // { id: 37, city: "Gurugram", locality: "Golf Course Road" },
//     //     // { id: 38, city: "Gurugram", locality: "Sector 29" },
//     //     // { id: 39, city: "Gurugram", locality: "Sector 45" },
//     //     // { id: 40, city: "Gurugram", locality: "Sector 56" },
//     //     // { id: 41, city: "Gurugram", locality: "Sector 57" },
//     //     // { id: 42, city: "Gurugram", locality: "Sector 15" },
//     //     // { id: 43, city: "Gurugram", locality: "Udyog Vihar" }
//     // ];

//     const [filterdata, setFilterData] = useState<Locality[]>(localityArray)


//     // useEffect(() => {
//     //     setFilterData(localityArray)
//     // }, [])



//     // this is my onchange Event
//     const handleLocalityDropDown = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const value = e.target.value;
//         setInputValue(value);

//         if (value.trim() === "") {
//             setShowDropdown(false);
//             setFilterData([]);
//             return;
//         }

//         setShowDropdown(true);

//         const data = localityArray
//             .filter(locality =>
//             (
//                 locality.city.toLowerCase().includes(value.toLowerCase()) ||
//                 locality.locality.toLowerCase().includes(value.toLowerCase())
//             )
//             )
//             .filter(locality =>
//                 !searchInput.includes(locality.city) &&
//                 !searchInput.includes(locality.locality)  // optional if you're storing localities in chips too
//             );

//         setFilterData(data);
//     };





//     const handleDropDownClick = (city: string) => {
//         console.log("handleDropDownClick", city);
//         setInputValue("")
//         const value = city.trim();
//         setSearchInput(prev => [...prev, value])
//         setShowDropdown(false)
//     }


//     const handleClearInput = () => {
//         setInputValue("")
//         setShowDropdown(false)
//     }


//     // Start component here

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 title=''
//                 goBack={true}
//                 skip={true}
//                 clear={false}
//                 clearOnClicked={() => { }}
//             />
//         );
//     };

//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container' style={{ marginTop: 30 }}>
//                 <p className='headingCity ' style={{ textAlign: "left" }}>   You are looking to rent in</p>

//                 <div className='changeCityContainer'>
//                     <p className='paraCity leftText'>
//                         Select Locality in <span className="cityHighlight">{selectedCity}</span>
//                     </p>
//                     <p
//                         className='paraCity leftText boldText'
//                         // onClick={() => navigate('/onbording5')}
//                         onClick={handleChangeCity}
//                     >
//                         Change City</p>
//                 </div>


//             </div>
//         );
//     };


//     const renderLocalityList = (): JSX.Element => {
//         return (
//             <div className="container" style={{ marginTop: 40 }}>
//                 <p className='paraCity leftText '>Popular Localities</p>
//                 <div
//                     style={{
//                         maxHeight: 300,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {priceData.map((item) => (
//                         <div
//                             key={item.id}
//                             style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 padding: '8px',
//                                 border: '1px solid #ccc',
//                                 borderRadius: 5,
//                                 marginBottom: 10,
//                             }}
//                             onClick={() => handleLocalityClick(item.locality)}

//                         >
//                             <div
//                                 style={{
//                                     flex: '0 0 20px',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     marginRight: 12,
//                                 }}
//                             >
//                                 <svg
//                                     style={{ width: '20px', height: '20px' }}
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                 >
//                                     <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth="2"
//                                         d="M12 4v16m8-8H4"
//                                     />
//                                 </svg>
//                             </div>

//                             <div style={{ flex: 1 }}>
//                                 <text.T14
//                                     style={{
//                                         color: '#333',
//                                         // fontWeight: 'bold',
//                                         marginBottom: 5,
//                                         // fontSize: "10px"
//                                     }}
//                                 >
//                                     {item.locality}
//                                 </text.T14>

//                             </div>

//                         </div>
//                     ))}


//                 </div>
//             </div>
//         );
//     };

//     const renderButton = (): JSX.Element => {
//         return (
//             <div
//                 id="onbording3"
//                 style={{ backgroundColor: "#7065F0", color: "white" }}
//                 onClick={handleApply}
//             >
//                 <span>Apply</span>
//             </div>

//         );
//     };

//     const renderSearchBar = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div
//                     className="searchBar"
//                     style={{
//                         marginTop: "9px",
//                         display: "flex",
//                         alignItems: "center",
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                         padding: "5px 16px",
//                         gap: "6px",
//                     }}
//                 >
//                     <span style={{ flexShrink: 0 }}>
//                         <svg.SearchSvg />
//                     </span>



//                     {/* {searchInput.length > 0 && <div> | </div>} */}
//                     {/* Flexible input field */}
//                     <input
//                         type="text"
//                         placeholder="Search Localities here"
//                         className="searchInput"
//                         maxLength={30}
//                         style={{
//                             border: "none",
//                             outline: "none",
//                             flex: 1,
//                             minWidth: "120px",
//                         }}
//                         value={inputValue}
//                         // onKeyDown={handleKeyDown}
//                         onChange={(e) => handleLocalityDropDown(e)}
//                     />

//                     {
//                         inputValue && <span style={{ flexShrink: 0 }} onClick={handleClearInput}>
//                             <CrossSvg color="#000000c7" width={13} height={13} style={{ marginRight: 8 }} />

//                         </span>
//                     }

//                 </div>
//                 {/* Chips for selected localities */}
//                 {searchInput.length > 0 && <div
//                     style={{
//                         display: "flex",
//                         overflow: "auto",
//                         flexWrap: "nowrap",
//                         gap: "6px",
//                         flex: 1,
//                         margin: "18px 0"
//                     }}>

//                     {searchInput.slice().reverse().map((loc, idx) => (
//                         <div
//                             key={idx}
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 backgroundColor: "#7065f0d6",
//                                 borderRadius: "5px",
//                                 padding: "9px 10px",
//                                 fontSize: "14px",
//                                 whiteSpace: "nowrap",
//                                 color: "white"
//                             }}
//                         >
//                             <span>{loc}</span>
//                             <span
//                                 style={{
//                                     cursor: "pointer",
//                                     fontWeight: "bold",
//                                     color: "#fff",
//                                     marginLeft: "8px",

//                                 }}
//                                 onClick={() => handleRemoveChips(loc)}
//                             >
//                                 ×
//                             </span>
//                         </div>
//                     ))}

//                 </div>}


//                 {/* Show Dropdown when typing */}
//                 {/* {
//                     showDropdown && (
//                         <div className='cityResult'>
//                             {
//                                 filterdata.length > 0 ? (
//                                     filterdata.map((item, index) => (
//                                         <p key={index} onClick={() => handleDropDownClick(item.locality)}>
//                                             {item.locality} | {item.city}
//                                         </p>
//                                     ))
//                                 ) : (
//                                     <p style={{ padding: "8px" }}>No results found</p>
//                                 )
//                             }
//                         </div>
//                     )
//                 } */}

//                 {
//                     showDropdown && (

//                         <div className='localityResult'>
//                             {
//                                 filterdata.length > 0 ? (
//                                     filterdata.map((item, index) => (
//                                         <p key={index} onClick={() => handleDropDownClick(item.locality)}>
//                                             <span role="img" aria-label="location">
//                                                 <LocationIconSvg width={15} height={15} style={{ marginTop: 8 }} />
//                                             </span> {item.locality} | {item.city}
//                                         </p>
//                                     ))
//                                 ) : (
//                                     <p className="noResult">No results found</p>
//                                 )
//                             }
//                         </div>
//                     )
//                 }



//                 <div className="useLocation" style={{ marginTop: "10px" }}>
//                     <svg.LocationSvg />
//                     <span>Use My Current Location</span>
//                 </div>
//             </div>
//         );
//     };




//     const renderContent = (): JSX.Element => {
//         return (
//             <main
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     height: '100dvh', // or '100vh' if preferred
//                     paddingBottom: 10,
//                     overflow: "hidden"
//                 }}
//             >
//                 <div
//                     style={{
//                         flex: 1,
//                         overflowY: 'auto',
//                     }}
//                 >
//                     {renderTitle()}
//                     {renderSearchBar()}
//                     {renderLocalityList()}
//                 </div>

//                 <div style={{ padding: '0 20px 10px' }}>
//                     {renderButton()}
//                 </div>
//             </main>

//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };


